import React from "react";
import { getDecidiInsight } from "@/lib/vg2Decidi";

// V3 · commento salvato sulla versione DECIDI (e, con scenarioKey, sull'operazione).
export function useInsight(caseId, decisionResultId, scenarioKey, enabled = true) {
  const [state, setState] = React.useState({ phase: "loading", data: null });
  React.useEffect(() => {
    if (!enabled || !decisionResultId) return undefined;
    let alive = true;
    setState({ phase: "loading", data: null });
    getDecidiInsight(caseId, decisionResultId, scenarioKey)
      .then((d) => alive && setState({ phase: "ready", data: d }))
      .catch(() => alive && setState({ phase: "error", data: null }));
    return () => { alive = false; };
  }, [caseId, decisionResultId, scenarioKey, enabled]);
  return state;
}

export function InsightBlock({ state, decisionResultId, tid = "decidi-insight" }) {
  if (state.phase === "error") return null;
  return (
    <section className="mb-10 max-w-[680px] border-l-2 border-vg2-red pl-5" data-testid={tid}
             data-source={state.data?.source} data-decision-result-id={decisionResultId}>
      <h2 className="font-display font-semibold text-base md:text-lg text-vg2-ink mb-2" data-testid={`${tid}-title`}>
        Cosa emerge dall'analisi
      </h2>
      {state.phase === "loading" ? (
        <p className="text-sm text-vg2-muted animate-pulse" data-testid={`${tid}-loading`}>
          Sto leggendo i risultati di questa analisi…
        </p>
      ) : (
        <p className="font-display text-[1.05rem] leading-relaxed text-vg2-ink" data-testid={`${tid}-text`}>
          {state.data.text.replace(/€ /g, "€\u00a0")}
        </p>
      )}
    </section>
  );
}

export function DecidiInsight({ caseId, decisionResultId }) {
  const state = useInsight(caseId, decisionResultId);
  return <InsightBlock state={state} decisionResultId={decisionResultId} />;
}
